<template>
  <div id="app">
    <meta name="referrer" content="never">
    <router-view v-if="isRouterAlive" v-wechat-title='title'></router-view>
  </div>
</template>

<script>
import { Toast } from 'vant';
import Tool from './other/tool.js';
import { login,auth } from "./other/utils/auth.js"; 
export default {
  name: 'App',
  provide() {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
      checkToken: this.checkToken,
      setTitle: this.setTitle,
    }
  },
  data() {
    return {
      com: '',
      isRouterAlive: true,                   //控制视图是否显示的变量
      index: 1,
      title: "",
      showTab: false,
      loading: false,
      callback: null,
    };
  },
  watch: {
    '$route'(to, from) { 
      this.initRoute(this.$route.path);
      if(to.path === "/"){
        // debugger 
      } 
    },
  },
  beforeRouteLeave(to, from, next) {
    console.log('组件内离开守卫', to, from);
    next(); // 必须调用 next()
  },
  created() {
   
    // this.getSysStatus(); 
    this.initRoute(this.$route.path); 
    this.getCode()
  },
  methods: { 
    getCode(){
      console.log(this.$route.path,'--------')
      let str = this.$route.path 
      let fullPath = window.location.href
      let code = ''
      if(str.lastIndexOf("=") > -1 || str.lastIndexOf("/") > -1){ 
        
        if(str.lastIndexOf("=") > -1){  
          code = str.substring(
            str.lastIndexOf("=") + 1
          );  
        }
        if(str.lastIndexOf("/") > -1){  
          code = str.substring(
            str.lastIndexOf("/") + 1
          );  
        }
        if(code){
          code = code.trim()
        }
        console.log(code)
        if(code.length === 16){
          localStorage.setItem('fullCode',fullPath)  
          localStorage.setItem('qr',code)  
          this.$router.replace({
            path:"/a_index",
            query:{
              qr:code
            }
          }) 
        }else if(code.length){
          Toast("此码非此活动产品瓶码,请重新扫描")
        }
      }
    },
    initRoute(path) { 
      //debugger
      //初始化
      //this.com = Tool.getUrlKey("com", window.location.href);
      //if (window.location.href.indexOf("/home?") != -1) {
      //  this.active = 1;
      //} else if (window.location.href.indexOf("/product?") != -1) {
      //  this.active = 2;
      //} else if (window.location.href.indexOf("/cart?") != -1) {
      //  this.active = 3;
      //} else if (window.location.href.indexOf("/my?") != -1) {
      //  this.active = 4;
      //}
    },
    setTitle(title, showTab) {
      this.title = title;
      this.showTab = showTab;
    },
    checkToken(callback) { 
      this.userLogin(callback);
    },

    selectItem(active) {
      this.active = active;
      switch (active) {
        case 1:
          this.$router.replace('/home?com=' + this.com);
          break;
        case 2:
          this.$router.replace('/product?com=' + this.com);
          break;
        case 3:
          this.$router.replace('/cart?com=' + this.com);
          break;
        case 4:
          this.$router.replace('/my?com=' + this.com);
          break;
      }
    },
    reload() {
      this.isRouterAlive = false;            //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true;         //再打开
      })
    },

    async userLogin(callback) { 
      this.callback = callback;
      if(this.loading) return;
      this.loading = true;
      let code = Tool.getUrlKey("code", window.location.href);
      let old = localStorage.getItem("code");
      if(code && code != old) { 
        let res = await login();
        console.log(res);
      }
      this.loading = false;
      typeof this.callback == 'function' && this.callback();
    },

    // 系统状态
    getSysStatus() {
      this.$http.get("/ActCtrl/getActOffLine")
      .do(res => {
        if(res.cont == 20001) {
          this.$router.replace('/');
          window.location.href = "/static/upgrade.html";
        }
      })
    },
  },
}
</script>


<style type="text/css">
@import "./res/css/main.css";
@import "./res/css/index.css";

.bar {
  z-index: 9999;
  position: fixed;
  bottom: 0;
  height: 60px;
  width: 100%;
  background-color: rgb(250, 250, 250);
}

.barItem {
  text-align: center;
  line-height: 23px;
  height: 60px;
  font-size: 16px;
  margin-top: 5px;
}

.barItemSelect {
  text-align: center;
  line-height: 23px;
  height: 60px;
  font-size: 16px;
  color: #00ad19;
  margin-top: 5px;
  /*border-bottom: 2px solid #00ad19;;*/
}

#app {
  width: 100%;
  height: 100vh;
  overflow: auto; 
}
</style>



// WEBPACK FOOTER //
// App.vue?14426437